export enum COMMON_PAGE_PATHS {
    PRESENTATION = 'presentation',
    PRESENTER = 'presenter',
    QANDA = 'qanda',
    NOT_FOUND = '404',
    POLLS = 'polls'
}


export const loginPagePath = (presenterEmbedId:string):string => `${COMMON_PAGE_PATHS.PRESENTATION}/${presenterEmbedId}`;

export const mainPagesPaths = (presenterEmbedId:string, pageName:COMMON_PAGE_PATHS):string => `${loginPagePath(presenterEmbedId)}/${pageName}`;

export const graphQLDomainName = (): string => {
  try {
    return new URL(`${process.env.REACT_APP_GRAPH_QL_API}`).hostname;
  } catch (e) {
    const error = e as Error;
    return error.toString();
  }
};

export const KvApiDomaninName = (): string => {
  try {
    return new URL(`${process.env.REACT_APP_API_BASE}`).hostname;
  } catch (e) {
    const error = e as Error;
    return error.toString();
  }
};

const negative = -1;
export const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > negative &&
  navigator.userAgent && navigator.userAgent.indexOf('CriOS') === negative &&
  navigator.userAgent.indexOf('FxiOS') === negative;

